import classNames from 'classnames';
import React from 'react';
import addTestId from '../utils/addTestId';
import * as styles from './SettingCard.module.scss';

interface SettingCardProps {
  actions?: React.ReactNode;
  description?: React.ReactNode;
  details?: React.ReactNode;
  disabled?: boolean;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  testId?: string;
}

const SettingCard = ({
  actions,
  description,
  details,
  disabled = false,
  icon,
  title,
  testId,
}: SettingCardProps) => (
  <div
    {...addTestId(testId)}
    className={classNames(styles.container, {
      [styles.titleOnly]: !details,
      [styles.disabled]: disabled,
    })}
  >
    {!!icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.content}>
      {!!title && <h5>{title}</h5>}
      {description}
      {!!details && <div className={styles.details}>{details}</div>}
    </div>
    {!!actions && <div className={styles.actions}>{actions}</div>}
  </div>
);

export default SettingCard;
